import React from "react"

export const ICMenu = props => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13 12.4545H0" stroke="currentColor" strokeWidth="1.5" />
    <path d="M16 6.99986H0" stroke="currentColor" strokeWidth="1.5" />
    <path d="M10 1.54539H0" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)

export const ICClose = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6673 1.35357L2.35355 12.6673"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M13.6672 12.6673L2.35348 1.35355"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
)

export const ICRectangle = props => (
  <svg
    width="180"
    height="80"
    viewBox="0 0 180 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="180" height="80" rx="20" fill="#E4E4E4" fillOpacity="0.2" />
  </svg>
)

export const ICChevronLeft = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.10145 3.33325L9.09524 4.33399L4.17715 9.28563H19.5714V10.7142H4.17905L9.09524 15.6658L8.10145 16.6666L2.47429 10.9999L2.46999 11.0056L1.4762 10.0048L8.10145 3.33325Z"
      fill="currentColor"
    />
  </svg>
)

export const ICRightOutline = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.391846 14.504L1.80785 15.92L9.72785 8L1.80785 0.0800047L0.391846 1.496L6.89585 8L0.391846 14.504Z"
      fill="currentColor"
    />
  </svg>
)

export const ICLeftOutline = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Arrow-Forward-iOS-1"
        transform="translate(5.000000, 8.000000) scale(-1, 1) translate(-5.000000, -8.000000) "
        fill="currentColor"
      >
        <polygon
          id="Path"
          points="0.391846 14.5041 1.80785 15.9201 9.72785 8.00008 1.80785 0.0800781 0.391846 1.49608 6.89585 8.00008"
        />
      </g>
    </g>
  </svg>
)

export const MAPOutlineDash = (
  <svg
    width="1440"
    height="900"
    viewBox="0 0 1440 900"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1056.16 459.683L1071.15 454.01L1088.45 429.05V412.031L1105.74 401.82L1128.81 385.937L1153.02 396.148L1188.77 374.591L1212.98 371.188L1240.66 374.591L1264.87 364.38L1275.25 385.937L1264.87 396.148L1291.39 412.031H1306.38L1323.68 429.05L1346.74 436.992L1358.27 429.05V412.031H1383.64L1413.62 429.05H1443.6H1471.27L1486.26 459.683L1493.18 476.701L1505.86 500.526L1515.09 523.217V541.37L1531.23 554.985L1540.46 582.214L1558.91 594.694L1575.05 613.982L1581.97 632.134L1594.65 640.076L1615.41 644.614L1654.61 632.134V660.498L1637.32 688.862L1621.17 713.822L1599.26 734.244L1575.05 761.473L1554.29 784.164L1540.46 809.124L1547.37 839.757L1558.91 854.506V879.467V902.158L1547.37 921.445L1525.47 927.118L1515.09 941.867L1500.1 958.885L1505.86 987.249L1500.1 999.729L1483.96 1011.07L1475.88 1021.29V1032.63L1472.42 1046.25L1444.75 1079.15L1419.38 1096.17L1397.47 1106.38L1385.94 1096.17L1370.95 1106.38H1351.35L1343.28 1096.17V1079.15L1334.05 1058.73L1315.61 1037.17V1021.29L1308.69 987.249L1298.31 958.885L1283.32 936.194V915.772L1291.39 896.485L1298.31 873.794V854.506V839.757L1291.39 822.739L1283.32 797.779L1275.25 788.702L1264.87 772.819V754.666V727.437V713.822L1248.73 701.342H1226.82L1217.59 688.862L1202.6 680.92L1183 688.862L1158.79 695.669H1128.81L1098.83 701.342L1079.22 695.669L1050.4 672.978L1042.33 660.498L1031.95 644.614L1022.72 632.134L1016.96 624.193V609.443L1008.89 598.098L1016.96 584.483V560.658V549.312V535.698V519.814L1031.95 500.526L1042.33 476.701L1056.16 459.683Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M660.656 1308.33L629.523 1291.31H607.615L577.635 1278.83L562.645 1255L543.042 1227.77L551.114 1217.56V1202.81L543.042 1188.06L526.899 1167.64V1147.22L521.134 1092.76L513.062 1043.98V998.595V956.616L490 930.521L461.173 912.369L442.724 887.408L424.275 857.91L408.132 820.47L395.448 814.797V788.702L408.132 778.492L395.448 763.742L408.132 739.917L424.275 714.957L432.346 703.611V687.727L424.275 660.498V652.556L432.346 660.498L442.724 652.556L454.255 638.942H466.939L478.47 624.193H490L495.766 644.614L490 660.498L478.47 644.614L503.837 629.865H521.134L531.511 638.942L549.961 644.614L571.869 638.942L585.706 644.614L612.227 676.382L623.758 687.727H642.207L668.728 695.669L680.259 714.957L688.33 731.975V745.59L702.167 753.531L714.851 763.742H730.994L739.066 769.415L755.209 778.492H779.424L799.026 788.702L820.935 801.183L833.619 806.855V820.47V839.757L815.169 869.256L799.026 887.408V912.369V947.54L779.424 980.442L763.281 986.114L739.066 998.595L721.77 1014.48V1030.36L714.851 1060.99L695.249 1092.76L680.259 1106.38H666.422H653.738L660.656 1118.86V1137.01L645.666 1147.22H629.523V1167.64H607.615V1180.12L616.839 1188.06L607.615 1208.49V1217.56V1227.77L616.839 1241.39V1255L607.615 1268.62L616.839 1278.83L607.615 1308.33H623.758L637.595 1314L660.656 1308.33Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M2042.05 539.101L2031.67 519.814L1995.92 525.487L1987.85 548.178L1969.4 560.658L1934.81 592.425L1929.04 610.578V645.749C1926.28 667.533 1910.98 663.902 1903.68 659.364L1882.92 618.52L1857.55 560.658V532.294H1842.56H1826.42V514.141H1809.12L1789.52 486.912L1776.84 497.123L1744.55 486.912H1715.72L1698.43 473.297L1658.07 468.759L1639.62 447.203L1626.94 436.992L1618.87 447.203L1632.7 463.086L1639.62 486.912H1658.07L1670.75 502.796L1691.51 486.912L1703.04 497.123L1727.26 514.141V532.294L1708.81 560.658L1684.59 572.003L1658.07 586.753L1632.7 600.367L1613.1 618.52H1588.89L1577.35 600.367V579.945L1564.67 560.658L1542.76 539.101V519.814L1508.17 480.105L1497.79 452.875L1485.11 463.086L1471.27 425.646H1492.03L1497.79 398.417V373.457L1478.19 380.264L1452.82 373.457H1425.15L1410.16 343.959V333.748H1396.32L1382.48 343.959L1389.4 359.842L1382.48 373.457L1366.34 365.515L1372.11 354.17L1352.5 343.959L1344.43 314.46L1323.68 301.98L1293.7 281.558C1280.78 269.759 1284.47 282.693 1287.93 290.635L1302.92 307.653C1314.84 316.351 1336.82 333.748 1329.44 333.748C1322.06 333.748 1322.52 351.144 1323.68 359.842L1302.92 333.748L1270.64 307.653L1254.49 296.307L1225.67 307.653H1209.52L1199.14 325.806L1174.93 343.959V365.515L1146.1 373.457H1119.58L1098.83 359.842L1106.9 307.653H1154.17L1164.55 296.307V272.482L1146.1 252.06L1174.93 246.387L1199.14 232.773L1231.43 207.812H1244.11L1254.49 197.601V176.045L1267.18 165.834V180.583L1282.17 176.045V160.161L1270.64 152.219L1254.49 160.161L1237.2 152.219V122.721L1287.93 85.2808L1323.68 59.1861L1352.5 43.3024H1402.09L1432.07 59.1861L1478.19 64.8589C1492.95 76.6582 1484.34 83.3899 1478.19 85.2808H1459.74L1432.07 76.2044L1459.74 98.8954H1478.19L1492.03 85.2808L1508.17 76.2044L1515.09 64.8589L1534.69 76.2044L1564.67 64.8589H1603.88L1644.23 59.1861H1669.6L1655.76 43.3024L1661.53 31.9569H1685.74L1701.89 43.3024L1726.1 31.9569L1744.55 20.6114H1769.92V8.13134L1807.97 -0.945073H1832.19L1844.87 -10.0215H1866.78L1888.69 -0.945073H1920.97L1929.04 8.13134L1920.97 20.6114L1963.64 26.2842H1972.86H1993.62H2013.22H2050.12L2091.63 43.3024H2115.84H2135.45L2141.21 26.2842L2179.26 31.9569L2224.23 43.3024H2263.44H2289.96L2319.94 59.1861H2376.44L2386.82 52.3788H2414.49L2457.16 59.1861L2495.21 70.5317L2519.42 79.6081H2545.94L2562.09 96.6264H2528.65L2511.35 85.2808L2495.21 96.6264L2519.42 107.972V120.452L2495.21 137.47H2470.99C2447.01 143.824 2451.77 154.488 2457.16 159.027L2476.76 166.969L2482.52 196.467V227.1H2470.99L2441.01 196.467L2421.41 166.969L2430.63 129.528L2421.41 120.452L2407.57 129.528H2392.58H2376.44V148.816H2348.77H2307.26L2289.96 159.027L2278.43 186.256L2296.88 196.467H2315.33L2340.69 206.678H2354.53L2376.44 227.1L2392.58 242.983V255.464L2399.5 278.155L2386.82 271.347L2376.44 255.464L2360.3 232.773H2354.53L2360.3 255.464V278.155L2348.77 305.384H2330.32L2319.94 314.46L2315.33 328.075V338.286L2319.94 349.631L2340.69 364.38L2348.77 380.264L2340.69 392.744H2319.94L2315.33 372.322L2289.96 355.304L2278.43 338.286C2263.67 346.455 2258.44 341.689 2257.67 338.286L2243.84 328.075L2224.23 349.631L2243.84 364.38H2257.67L2278.43 372.322L2251.91 389.341L2278.43 413.166L2289.96 430.184L2296.88 454.01L2289.96 484.643L2278.43 507.334L2251.91 519.814L2224.23 525.487L2209.24 539.101L2194.25 525.487L2179.26 535.698L2172.34 553.851L2194.25 579.945L2209.24 604.905V633.269L2194.25 645.749L2183.88 659.364H2172.34V645.749L2152.74 633.269L2129.68 618.52H2121.61V633.269L2110.08 618.52L2100.85 592.425L2091.63 579.945L2080.1 586.753H2068.57V572.003L2060.5 553.851L2042.05 539.101Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M1465.51 322.402L1438.99 331.478L1422.84 308.787L1429.76 288.365L1452.82 270.213L1465.51 288.365H1483.96V270.213H1505.86V288.365L1525.47 300.845L1543.92 322.402L1525.47 331.478L1496.64 322.402H1465.51Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M1171.47 182.852L1191.07 211.216L1199.14 218.023L1191.07 228.234L1163.4 236.176H1141.49L1148.41 218.023V211.216L1163.4 195.332L1148.41 182.852V172.641V161.296H1163.4L1171.47 182.852Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M1108.05 198.736L1126.5 190.795C1141.26 184.441 1138.03 193.442 1134.57 198.736L1126.5 215.755L1108.05 224.831V198.736Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M1027.33 96.6261L1052.7 88.6843H1081.53L1094.21 96.6261L1068.85 111.375H1041.17L1027.33 96.6261Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M816.322 87.5499L827.853 69.3971C843.534 63.0436 843.611 50.1097 841.69 44.4369L827.853 19.4768L802.485 -0.945103H782.882L763.28 -8.88696V-21.367H802.485L827.853 -33.8471L863.598 -40.6544L920.099 -33.8471L954.691 -46.3271H1021.57H1068.85L1096.52 -33.8471L1079.22 -8.88696L1068.85 10.4004L1046.94 19.4768L1029.64 29.6878L1046.94 44.4369L1029.64 53.5134L997.355 63.7243L974.294 69.3971L954.691 77.3389L920.099 87.5499L887.813 104.568L863.598 137.47H841.69L816.322 119.317V87.5499Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M691.789 -28.1744L669.881 -8.88705L697.555 1.32391L719.463 -8.88705L747.137 -17.9635L797.873 -28.1744L831.312 -52L771.352 -45.1927H730.994V-28.1744H719.463H691.789Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M637.594 21.7458H614.532L591.47 34.2259L614.532 47.8405H637.594H664.115L684.87 72.8006V80.7425H664.115L650.278 96.6262L664.115 113.644L691.788 121.586L709.085 105.703V88.6843H718.309C744.138 95.0378 743.677 86.037 740.218 80.7425L726.381 62.5896L709.085 42.1677L691.788 34.2259H677.952L664.115 27.4185L637.594 21.7458Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M391.987 13.8038L374.691 21.7457L353.936 29.6876L360.854 42.1676L374.691 29.6876H397.753L406.978 42.1676L391.987 60.3204H412.743H426.58H445.029L465.785 55.7822L489.999 52.3786V42.1676V29.6876H481.928H471.55L461.172 21.7457L449.642 29.6876L434.651 21.7457L412.743 13.8038H391.987Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M718.31 241.849L740.218 255.463L718.31 262.271H696.401L686.024 255.463L696.401 247.522L718.31 228.234V241.849Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M495.765 357.573L536.123 326.94L561.491 318.998L577.634 299.711L605.308 284.962H615.685V299.711H632.982L659.503 284.962L632.982 273.616L642.206 249.791H622.604L632.982 231.638H665.268H690.636L716.003 219.158L733.3 203.274L716.003 197.601L703.32 179.448L696.401 140.874L665.268 157.892L653.737 140.874V128.394L615.685 117.048L596.083 128.394L584.552 152.219V168.103L561.491 188.525L541.888 197.601V212.35L524.592 225.965L513.061 212.35L519.98 185.121L495.765 179.448L480.775 168.103L457.713 152.219L472.703 128.394L503.837 117.048L524.592 105.703L551.113 97.7606L567.256 88.6842L596.083 97.7606L589.165 112.51L561.491 105.703L577.634 79.6078H605.308L622.604 67.1278V54.6477H605.308L577.634 67.1278L567.256 54.6477L561.491 36.4949L541.888 44.4367V54.6477L524.592 67.1278V54.6477H513.061V67.1278H495.765L472.703 72.8005L457.713 67.1278L430.039 72.8005V79.6078L398.906 72.8005L366.62 54.6477H329.721H299.741L252.465 67.1278L220.179 54.6477L140.616 44.4367H107.177L62.2067 54.6477L47.2166 61.455C39.9138 61.455 26.6918 65.0856 32.2266 79.6078L13.7773 88.6842H-9.28433C-11.5905 92.0879 -13.2048 100.257 -1.21277 105.703L-18.509 117.048H-39.2644L-49.6422 135.201L-64.6322 140.874L-49.6422 152.219L-90 185.121L-18.509 157.892L20.6958 140.874H32.2266L69.1252 128.394L101.411 140.874L125.626 157.892L137.157 172.641C133.313 186.256 125.626 217.115 125.626 231.638C146.382 231.638 160.219 253.194 148.688 257.732C139.463 261.363 117.17 287.231 107.177 299.711L80.656 334.882L88.7275 393.879L107.177 418.839V440.395L115.248 472.163L125.626 495.988L137.157 509.603V472.163L125.626 450.606V433.588H137.157V459.683L155.606 488.046L177.515 522.083V548.178L228.25 579.945H274.374L291.67 600.367L321.65 611.712H333.181L343.558 631L364.314 657.094L393.141 671.844L415.049 657.094H393.141L370.079 631V587.887H343.558L333.181 579.945L343.558 542.505C347.786 536.454 350.477 526.167 327.415 533.428L311.272 554.985L284.751 564.061L266.302 548.178L253.618 522.083L266.302 480.104L274.374 459.683L311.272 440.395L343.558 450.606L370.079 433.588L387.375 440.395L408.131 450.606V480.104L415.049 488.046L430.039 480.104V459.683L420.815 433.588L442.723 418.839L461.173 404.09L490 393.879V368.918L495.765 357.573Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M503.837 562.927H471.55L480.775 544.774H492.306L524.592 551.581L503.837 562.927Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M424.274 511.872H386.222L396.6 519.814L416.203 530.025L433.499 542.505L469.244 536.832L457.713 530.025L424.274 511.872Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M408.132 273.616H440.418L419.662 290.635L408.132 315.595L413.897 325.806L427.734 315.595L440.418 284.962H461.173V303.115L485.388 290.635V273.616H472.704L461.173 266.809L449.643 254.329H419.662L408.132 273.616Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M609.92 5.86196L666.421 16.0729L679.105 5.86196H645.666L624.91 -4.349L609.92 5.86196Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
    <path
      d="M1308.69 183.987L1319.07 164.699L1325.98 151.085L1331.75 140.874L1319.07 127.259V114.779L1343.28 106.837L1358.27 84.1461L1374.41 96.6261L1352.5 114.779L1358.27 135.201H1397.47L1412.46 140.874L1397.47 151.085H1374.41V164.699H1358.27V183.987L1343.28 194.198H1331.75L1308.69 202.139L1297.16 194.198H1272.94L1287.93 183.987H1308.69Z"
      stroke="#E4E4E4"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="2 8"
    />
  </svg>
)

export const MapFill = (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80.2583 37.4584L81.308 37.0432L82.5191 35.2159V33.9701L83.7303 33.2226L85.3451 32.0598L87.0407 32.8073L89.5438 31.2292L91.2394 30.98L93.1772 31.2292L94.8728 30.4817L95.5995 32.0598L94.8728 32.8073L96.7299 33.9701H97.7795L98.9907 35.2159L100.606 35.7973L101.413 35.2159V33.9701H103.189L105.289 35.2159H107.388H109.326L110.375 37.4584L110.86 38.7043L111.748 40.4485L112.394 42.1096V43.4385L113.524 44.4352L114.17 46.4285L115.462 47.3422L116.593 48.7541L117.077 50.083L117.965 50.6644L119.419 50.9966L122.164 50.083V52.1594L120.953 54.2358L119.822 56.0631L118.288 57.5581L116.593 59.5515L115.139 61.2126L114.17 63.0398L114.655 65.2824L115.462 66.3621V68.1893V69.8505L114.655 71.2624L113.121 71.6777L112.394 72.7574L111.344 74.0033L111.748 76.0797L111.344 76.9933L110.214 77.8239L109.649 78.5714V79.402L109.406 80.3986L107.469 82.8073L105.692 84.0531L104.158 84.8006L103.351 84.0531L102.301 84.8006H100.928L100.363 84.0531V82.8073L99.7174 81.3123L98.4255 79.7342V78.5714L97.941 76.0797L97.2143 74.0033L96.1647 72.3422V70.8471L96.7299 69.4352L97.2143 67.774V66.3621V65.2824L96.7299 64.0365L96.1647 62.2093L95.5995 61.5448L94.8728 60.382V59.0531V57.0598V56.0631L93.7424 55.1495H92.2083L91.5623 54.2358L90.5127 53.6544L89.14 54.2358L87.4444 54.7342H85.3451L83.2458 55.1495L81.8732 54.7342L79.8546 53.0731L79.2894 52.1594L78.5627 50.9966L77.9168 50.083L77.5131 49.5016V48.4219L76.9479 47.5913L77.5131 46.5946V44.8505V44.0199V43.0232V41.8604L78.5627 40.4485L79.2894 38.7043L80.2583 37.4584Z"
      fill="#C4C4C4"
    />
    <path
      d="M120.63 68.7708L119.096 70.5149L117.561 71.4286V73.588L116.835 75.1661V76.8272L117.561 77.7408H119.096L119.984 76.8272V75.1661L121.033 72.5083L121.518 70.5149V68.7708L121.033 67.9402L120.63 68.7708Z"
      fill="#C4C4C4"
    />
    <path
      d="M177.715 91.0299L178.28 89.6179H179.572L180.218 90.1163L179.572 91.0299L178.28 91.5282L177.715 91.0299Z"
      fill="#C4C4C4"
    />
    <path
      d="M169.883 83.0565L167.864 83.9701H165.2L164.069 84.6346L162.858 85.299L162.293 84.6346V83.9701L162.858 82.1429V79.6512V77.0764L163.666 75.5814L166.572 73.8372H167.864L169.883 71.7608L170.448 71.0133L171.498 69.8505L173.193 69.2691L174.324 69.8505L174.889 69.0199L175.939 68.2724L177.876 67.691C179.62 67.4253 179.464 68.1894 179.168 68.6047L178.28 69.8505L179.168 70.515L181.268 71.7608L182.721 69.8505V68.6047L183.609 67.2758L184.013 68.6047L185.063 69.8505V72.093L185.789 73.0897L187 75.5814L188.211 77.0764V78.5714L187.566 81.3123L186.354 83.0565L185.063 83.9701L184.013 86.0465L182.721 87.1263H181.51L180.945 87.7077L180.137 88.206L179.168 87.7077H177.876L176.907 87.1263V86.0465L176.504 85.299L175.696 83.9701L174.889 84.6346L173.92 83.0565L172.87 82.6412H171.982L169.883 83.0565Z"
      fill="#C4C4C4"
    />
    <path
      d="M191.037 93.7708H189.261C189.261 93.1728 189.907 92.4142 190.23 92.1096L192.249 91.0299L194.025 90.4485L195.559 89.3688V90.4485L194.59 91.0299L194.025 92.1096H193.217L192.249 93.1063L191.037 93.7708Z"
      fill="#C4C4C4"
    />
    <path
      d="M197.82 89.9502H196.77L197.174 88.7874V87.8738L198.304 87.3754L198.789 85.6312L199.273 86.8771L200 87.8738L198.789 88.7874L197.82 89.9502Z"
      fill="#C4C4C4"
    />
    <path
      d="M50.3837 98.3389L52.5637 99.5848L50.9489 100L49.9799 99.5848H48.8495L49.2222 98.3389H48.8495L46.7502 97.4253L45.7006 95.6811L44.3279 93.6878L44.8931 92.9403V91.8605L44.3279 90.7808L43.1975 89.2858V87.7908L42.7938 83.804L42.2286 80.2326V76.9104V73.8373L40.6138 71.927L38.5952 70.5981L37.3033 68.7708L36.0114 66.6113L34.881 63.8705L33.9929 63.4552V61.5449L34.881 60.7974L33.9929 59.7177L34.881 57.9735L36.0114 56.1462L36.5766 55.3157V54.1529L36.0114 52.1595V51.5781L36.5766 52.1595L37.3033 51.5781L38.1107 50.5814H38.9989L39.8063 49.5017H40.6138L40.8467 50.3643L41.5827 49.917H42.7938L43.5205 50.5814L44.8124 50.9967L46.3465 50.5814L47.3154 50.9967L49.1725 53.3223L49.9799 54.1529H51.2718L53.1289 54.7343L53.9363 56.1462L54.5015 57.3921V58.3888L55.4705 58.9701L56.3586 59.7177H57.489L58.0542 60.1329L59.1846 60.7974H60.8802L62.2528 61.5449L63.787 62.4585L64.6751 62.8738V63.8705V65.2824L63.3832 67.4419L62.2528 68.7708V70.5981V73.1728L60.8802 75.5815L59.7498 75.9967L58.0542 76.9104L56.8431 78.0731V79.2359L56.3586 81.4785L54.986 83.804L53.9363 84.8007H52.9674H52.0793L52.5637 85.7143V87.0432L51.5141 87.7908H50.3837V89.2858H48.8495V90.1994L49.4955 90.7808L48.8495 92.2758V92.9403V93.6878L49.4955 94.6844V95.6811L48.8495 96.6778L49.4955 97.4253L49.2222 98.3389H50.3837Z"
      fill="#C4C4C4"
    />
    <path
      d="M187.646 64.9502L189.423 66.6943L188.857 67.2757L187.646 66.6943L186.274 65.4485L185.466 64.9502H184.578L184.013 65.8638L182.398 65.4485L181.51 64.9502H180.702L181.51 63.7043L180.702 62.9568L178.442 62.0432L177.23 61.6279V60.7973L176.423 59.3854H178.442V60.0498L179.33 61.6279L180.137 60.7973L181.51 60.0498L182.963 60.7973L185.466 61.6279L187.162 62.9568L187.646 64.9502Z"
      fill="#C4C4C4"
    />
    <path
      d="M164.796 55.5648L163.181 56.8107L161.566 57.6413L161.889 59.5516L162.697 60.8805L164.796 61.711H166.411V60.8805L167.622 59.1363L168.107 58.4718V57.309L167.622 56.3123L168.107 54.9004L167.622 54.0698H166.411L164.796 55.5648Z"
      fill="#C4C4C4"
    />
    <path
      d="M163.585 63.7043L165.361 64.7841L164.473 65.2824L162.697 64.7841H161.324H159.709L159.306 63.7043H160.678H162.051H163.585Z"
      fill="#C4C4C4"
    />
    <path
      d="M159.386 61.1296V62.3754C159.386 63.3721 158.256 63.2337 157.691 63.0399L156.56 61.794L155.511 59.4684L153.896 57.0598L152.523 55.7309V54.5681L155.188 55.7309L155.995 57.0598L157.691 58.3057V59.1362L159.386 61.1296Z"
      fill="#C4C4C4"
    />
    <path
      d="M168.107 47.0099L168.51 45.3488C168.672 44.6844 169.17 45.072 169.398 45.3488V47.0099L170.287 47.7574L171.256 49.3355L172.628 50.9967L173.193 52.5747V54.402H172.063L171.256 53.4883L170.287 51.4119L169.398 49.3355L168.107 47.0099Z"
      fill="#C4C4C4"
    />
    <path
      d="M156.237 56.3954L155.511 54.1529L154.138 51.9935V49.4187L155.107 50.4154V51.4951L155.511 52.4087L156.237 53.3224L157.61 54.1529L158.175 55.5649V57.5582H157.61L156.237 56.3954Z"
      fill="#C4C4C4"
    />
    <path
      d="M149.293 43.2725L148.567 41.8605L146.064 42.2758L145.499 43.9369L144.207 44.8505L141.784 47.1761L141.381 48.505V51.0798C141.187 52.6744 140.116 52.4087 139.604 52.0764L138.151 49.0864L136.375 44.8505V42.7741H135.325H134.195V41.4452H132.983L131.611 39.4519L130.723 40.1994L128.462 39.4519H126.443L125.232 38.4552L122.406 38.123L121.114 36.5449L120.226 35.7974L119.661 36.5449L120.63 37.7077L121.114 39.4519H122.406L123.294 40.6147L124.748 39.4519L125.555 40.1994L127.251 41.4452V42.7741L125.959 44.8505L124.263 45.6811L122.406 46.7608L120.63 47.7575L119.257 49.0864H117.562L116.754 47.7575V46.2625L115.866 44.8505L114.332 43.2725V41.8605L111.91 38.9535L111.183 36.9602L110.295 37.7077L109.326 34.9668H110.779L111.183 32.9735V31.1462L109.81 31.6445L108.034 31.1462H106.096L105.046 28.9867V28.2392H104.077L103.109 28.9867L103.593 30.1495L103.109 31.1462L101.978 30.5648L102.382 29.7343L101.009 28.9867L100.444 26.8273L98.9907 25.9137L96.8914 24.4186C95.9871 23.5548 96.2454 24.5017 96.4877 25.0831L97.5373 26.3289C98.3717 26.9657 99.9112 28.2392 99.3944 28.2392C98.8777 28.2392 98.91 29.5128 98.9907 30.1495L97.5373 28.2392L95.2765 26.3289L94.1461 25.4984L92.1276 26.3289H90.9972L90.2705 27.6578L88.5749 28.9867V30.5648L86.5563 31.1462H84.6992L83.2458 30.1495L83.811 26.3289H87.1215L87.8482 25.4984V23.7542L86.5563 22.2592L88.5749 21.8439L90.2705 20.8472L92.5313 19.02H93.4194L94.1461 18.2725V16.6944L95.0343 15.9469V17.0266L96.084 16.6944V15.5316L95.2765 14.9502L94.1461 15.5316L92.935 14.9502V12.7907L96.4877 10.0499L98.9907 8.13957L101.009 6.97677H104.481L106.581 8.13957L109.81 8.55485C110.844 9.41864 110.241 9.91144 109.81 10.0499H108.518L106.581 9.38541L108.518 11.0465H109.81L110.779 10.0499L111.91 9.38541L112.394 8.55485L113.767 9.38541L115.866 8.55485H118.611L121.437 8.13957H123.214L122.245 6.97677L122.648 6.14621H124.344L125.474 6.97677L127.17 6.14621L128.462 5.31564H130.238V4.40202L132.903 3.73757H134.598L135.486 3.07312H137.021L138.555 3.73757H140.815L141.381 4.40202L140.815 5.31564L143.803 5.73093H144.449H145.902H147.275H149.859L152.765 6.97677H154.461H155.834L156.237 5.73093L158.902 6.14621L162.051 6.97677H164.796H166.653L168.752 8.13957H172.709L173.436 7.64123H175.373L178.361 8.13957L181.025 8.97013L182.721 9.63458H184.578L185.708 10.8804H183.367L182.156 10.0499L181.025 10.8804L182.721 11.711V12.6246L181.025 13.8705H179.33C177.65 14.3356 177.984 15.1163 178.361 15.4485L179.734 16.0299L180.137 18.1894V20.4319H179.33L177.23 18.1894L175.858 16.0299L176.504 13.2891L175.858 12.6246L174.889 13.2891H173.839H172.709V14.701H170.771H167.864L166.653 15.4485L165.846 17.4419L167.138 18.1894H168.43L170.206 18.9369H171.175L172.709 20.4319L173.839 21.5947V22.5083L174.324 24.1695L173.436 23.6711L172.709 22.5083L171.578 20.8472H171.175L171.578 22.5083V24.1695L170.771 26.1628H169.479L168.752 26.8273L168.43 27.824V28.5715L168.752 29.402L170.206 30.4818L170.771 31.6445L170.206 32.5582H168.752L168.43 31.0632L166.653 29.8173L165.846 28.5715C164.812 29.1695 164.446 28.8206 164.392 28.5715L163.423 27.824L162.051 29.402L163.423 30.4818H164.392L165.846 31.0632L163.989 32.309L165.846 34.0532L166.653 35.299L167.138 37.0432L166.653 39.2857L165.846 40.9469L163.989 41.8605L162.051 42.2758L161.001 43.2725L159.952 42.2758L158.902 43.0233L158.417 44.3522L159.952 46.2625L161.001 48.0897V50.1661L159.952 51.0798L159.225 52.0764H158.417V51.0798L157.045 50.1661L155.43 49.0864H154.865V50.1661L154.057 49.0864L153.411 47.1761L152.765 46.2625L151.958 46.7608H151.151V45.6811L150.585 44.3522L149.293 43.2725Z"
      fill="#C4C4C4"
    />
    <path
      d="M172.144 34.6345L171.74 33.4717L171.982 32.7242L172.709 31.9766H173.678L174.808 31.2291L175.939 29.9002L175.454 28.8205L174.566 27.0763V25.9966V24.7507L175.616 25.4982L177.069 25.9966L176.665 26.8271H175.616V28.073H176.342L177.069 29.2358V30.1494L177.392 31.2291V32.558H175.939L175.05 33.4717L174.082 33.3055H173.355L172.709 32.9733L172.305 33.3055L172.951 34.0531L172.709 35.0497L172.144 34.6345Z"
      fill="#C4C4C4"
    />
    <path
      d="M121.437 31.5615L119.499 30.2326V28.2392L117.481 26.1628V25L119.499 23.0897L121.033 24.3356L120.387 25H119.499V26.1628L121.033 26.9103H122.083L122.648 27.8239L121.437 28.2392L122.083 29.402L122.648 30.6479L121.437 31.5615Z"
      fill="#C4C4C4"
    />
    <path
      d="M108.922 27.4086L107.065 28.0731L105.935 26.4119L106.419 24.9169L108.034 23.588L108.922 24.9169H110.214V23.588H111.748V24.9169L113.121 25.8305L114.413 27.4086L113.121 28.0731L111.102 27.4086H108.922Z"
      fill="#C4C4C4"
    />
    <path
      d="M88.3327 17.1927L89.7053 19.2691L90.2705 19.7674L89.7053 20.515L87.7675 21.0964H86.2333L86.7178 19.7674V19.2691L87.7675 18.1063L86.7178 17.1927V16.4452V15.6146H87.7675L88.3327 17.1927Z"
      fill="#C4C4C4"
    />
    <path
      d="M83.8918 18.3555L85.1837 17.7741C86.2172 17.309 85.9911 17.9679 85.7489 18.3555L85.1837 19.6014L83.8918 20.2658V18.3555Z"
      fill="#C4C4C4"
    />
    <path
      d="M78.2397 10.8803L80.016 10.299H82.0346L82.9228 10.8803L81.1464 11.9601H79.2086L78.2397 10.8803Z"
      fill="#C4C4C4"
    />
    <path
      d="M63.4639 10.2159L64.2713 8.88704C65.3694 8.42193 65.3748 7.47508 65.2402 7.0598L64.2713 5.23256L62.495 3.73754H61.1223L59.7497 3.15615V2.24253H62.495L64.2713 1.3289L66.7743 0.830566L70.7307 1.3289L73.153 0.415283H77.8361H81.1465L83.0844 1.3289L81.8732 3.15615L81.1465 4.56811L79.6124 5.23256L78.4013 5.98007L79.6124 7.0598L78.4013 7.72425L76.1405 8.47176L74.5256 8.88704L73.153 9.46844L70.7307 10.2159L68.4699 11.4618L66.7743 13.8704H65.2402L63.4639 12.5415V10.2159Z"
      fill="#C4C4C4"
    />
    <path
      d="M54.7436 1.74419L53.2095 3.15615L55.1474 3.90365L56.6815 3.15615L58.6193 2.49169L62.172 1.74419L64.5135 0L60.3149 0.498339H57.4889V1.74419H56.6815H54.7436Z"
      fill="#C4C4C4"
    />
    <path
      d="M50.9487 5.39868H49.3339L47.719 6.3123L49.3339 7.30898H50.9487H52.8058L54.2592 9.13622V9.71762H52.8058L51.8369 10.8804L52.8058 12.1263L54.7436 12.7077L55.9548 11.5449V10.299H56.6007C58.4093 10.7641 58.377 10.1052 58.1348 9.71762L57.1659 8.38872L55.9548 6.8937L54.7436 6.3123H53.7747L52.8058 5.81396L50.9487 5.39868Z"
      fill="#C4C4C4"
    />
    <path
      d="M33.7505 4.81738L32.5394 5.39878L31.086 5.98017L31.5705 6.8938L32.5394 5.98017H34.1542L34.8002 6.8938L33.7505 8.2227H35.2039H36.1728H37.4647L38.9181 7.89047L40.6137 7.6413V6.8938V5.98017H40.0485H39.3218L38.5951 5.39878L37.7877 5.98017L36.738 5.39878L35.2039 4.81738H33.7505Z"
      fill="#C4C4C4"
    />
    <path
      d="M56.6007 21.5116L58.1348 22.5082L56.6007 23.0066H55.0666L54.3399 22.5082L55.0666 21.9269L56.6007 20.5149V21.5116Z"
      fill="#C4C4C4"
    />
    <path
      d="M43.8433 27.741L41.0173 29.9835L40.6136 30.8141V32.6413L38.5951 33.3888L37.3032 34.4686L35.7691 35.5483L36.415 37.4586V38.9536L35.3653 39.535L34.8809 38.9536V36.7941L33.4275 36.0466L32.2164 35.5483L30.3593 36.7941L28.0985 36.0466L25.5147 37.4586L24.9495 38.9536L24.0614 42.0267L24.9495 43.937L26.2414 45.0998L28.0985 44.4353L29.2289 42.8573C30.8438 42.3257 30.6554 43.0787 30.3593 43.5217L29.6326 46.2626L30.3593 46.844H32.2164V50.0001L33.8312 51.9104H35.3653L33.8312 52.9901L31.8127 51.9104L30.3593 50.0001L29.6326 48.5882H28.8252L26.7259 47.7576L25.5147 46.2626H22.285L18.7323 43.937V42.0267L17.1982 39.535L15.9063 37.4586V35.5483H15.0989V36.7941L15.9063 38.3722V41.1131L15.0989 40.1164L14.3722 38.3722L13.807 36.0466V34.4686L12.5151 32.6413L11.9499 28.3224L13.807 25.7476C14.5068 24.834 16.0678 22.9403 16.7138 22.6745C17.5212 22.3423 16.5523 20.7642 15.0989 20.7642C15.0989 19.7011 15.6372 17.442 15.9063 16.4453L15.0989 15.3656L13.4033 14.1197L11.1425 13.2061L8.55874 14.1197H7.75131L5.00605 15.3656L0 17.3589L2.826 14.9503L1.77634 14.1197L2.826 13.7044L3.55268 12.3755H5.00605L6.2172 11.545C5.37747 11.1463 5.49051 10.5483 5.652 10.2991H7.26685L8.55874 9.63466C8.17117 8.57154 9.09702 8.30576 9.60839 8.30576L10.6581 7.80742L13.807 7.05991H16.1486L21.7198 7.80742L23.9806 8.72104L27.2911 7.80742H29.3904H31.9742L34.235 9.13632L36.415 9.63466V9.13632L38.3528 8.72104L39.4025 9.13632L41.0173 8.72104H42.2285V7.80742H43.0359V8.72104L44.2471 7.80742V7.05991L45.6197 6.47852L46.0234 7.80742L46.7501 8.72104L48.6879 7.80742H49.8991V8.72104L48.6879 9.63466H46.7501L46.3025 10.391L48.042 10.9636L47.5575 12.0433L45.6197 11.545L46.3025 10.391L46.0234 10.2991L44.893 10.9636L43.0359 11.545L41.5825 12.3755L39.4025 13.2061L38.3528 14.9503L39.9677 16.1131L41.0173 16.9436L42.7129 17.3589L42.2285 19.3523L43.0359 20.3489L44.2471 19.3523V18.2725L45.6197 17.6081L47.2345 16.1131V14.9503L48.042 13.2061L49.4146 12.3755L52.0791 13.2061V14.1197L52.8865 15.3656L55.0666 14.1197L55.5511 16.9436L56.4392 18.2725L57.6504 18.6878L56.4392 19.8506L54.6629 20.7642H52.8865H50.6257L49.8991 22.0931H51.2717L50.6257 23.8373L52.4828 24.6679L50.6257 25.7476H49.4146V24.6679H48.6879L46.7501 25.7476L45.6197 27.1596L43.8433 27.741Z"
      fill="#C4C4C4"
    />
    <path
      d="M41.5826 45.0166H39.3218L39.9677 43.6877H40.7751L43.0359 44.1861L41.5826 45.0166Z"
      fill="#C4C4C4"
    />
    <path
      d="M36.0113 41.2791H33.3468L34.0735 41.8604L35.4461 42.608L36.6573 43.5216L39.1603 43.1063L38.3529 42.608L36.0113 41.2791Z"
      fill="#C4C4C4"
    />
    <path
      d="M34.8809 23.8373H37.1417L35.6883 25.0831L34.8809 26.9103L35.2846 27.6579L36.2535 26.9103L37.1417 24.6678H38.5951V25.9967L40.2907 25.0831V23.8373H39.4025L38.5951 23.3389L37.7877 22.4253H35.6883L34.8809 23.8373Z"
      fill="#C4C4C4"
    />
    <path
      d="M49.0109 4.23579L52.9673 4.9833L53.8554 4.23579H51.5139L50.0605 3.48828L49.0109 4.23579Z"
      fill="#C4C4C4"
    />
    <path
      d="M53.371 0.996704L52.8058 2.1595H51.6754L50.545 1.74421L51.6754 0.996704H53.371Z"
      fill="#C4C4C4"
    />
    <path
      d="M97.941 17.2758L98.6677 15.8638L99.1522 14.8671L99.5559 14.1196L98.6677 13.1229V12.2093L100.363 11.6279L101.413 9.9668L102.543 10.8804L101.009 12.2093L101.413 13.7043H104.158L105.208 14.1196L104.158 14.8671H102.543V15.8638H101.413V17.2758L100.363 18.0233H99.5559L97.941 18.6047L97.1336 18.0233H95.438L96.4876 17.2758H97.941Z"
      fill="#C4C4C4"
    />
    <path
      d="M168.107 61.0465L168.833 59.1362C168.446 58.5382 168.995 57.9458 169.318 57.7243C169.318 57.3256 171.417 57.5582 172.467 57.7243C172.467 59.0532 170.959 58.6102 170.206 58.2226L169.641 58.804L169.883 59.6346H171.094L170.206 60.3821L170.69 61.5449L170.206 62.1263L169.641 61.0465L169.318 61.5449V63.0399L168.107 62.7907V61.0465Z"
      fill="#C4C4C4"
    />
  </svg>
)

export const RippleAnimate = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="80"
    height="80"
    viewBox="0 0 110 110"
    preserveAspectRatio="xMidYMid"
  >
    <circle cx={50} cy={50} r={5} fill="#000"/>
    <circle cx={50} cy={50} r={0} fill="none" stroke="#7E7E7E" strokeWidth={2}>
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="0s"
      />
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="0s"
      />
    </circle>
    <circle cx={50} cy={50} r={0} fill="none" stroke="#000" strokeWidth={2}>
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      />
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      />
    </circle>
  </svg>
);
